// AD-2677: an Admissions Categories question set to 'Only one category can be ticked' records the one category
// a place is allocated under. The same rule is checked on the server (RequiredAnswers.cs).
export const ONLY_ONE_CATEGORY_MESSAGE = 'Please tick only the category the place is allocated under.';

export const isOneAdmittingCategoryQuestion = (field) =>
    field?.key === 'admissionCategories' && field?.onlyOneCategory === true;

export const checkOneAdmittingCategory = (value) => {
    const ticked = Array.isArray(value)
        ? value.filter((id) => id != null && id !== '')
        : (value != null && value !== '' ? [value] : []);

    return ticked.length === 1
        ? {isValid: true, error: ''}
        : {isValid: false, error: ONLY_ONE_CATEGORY_MESSAGE};
};

// Ticking the setting shows every category on the form, so the officer can choose from the school's whole list.
export const withEveryCategoryShown = (options = []) =>
    options.map((option) => ({...option, hidden: false}));
